export function normalizeChatMessage(message: unknown): string {
  if (typeof message === "string") {
    return message;
  }

  if (message === null || message === undefined) {
    return "";
  }

  return String(message);
}

/**
 * Backend / membership templates sometimes send newlines as literal "\r\n" (four characters)
 * instead of CRLF. Map those to real newlines so CSS white-space: pre-line can render breaks.
 */
export function decodeLiteralNewlineEscapes(text: string): string {
  return text
    .replace(/\\r\\n/g, "\n")
    .replace(/\\n/g, "\n")
    .replace(/\\r/g, "\n");
}

export function formatChatMessageForDisplay(message: unknown): string {
  return decodeLiteralNewlineEscapes(normalizeChatMessage(message));
}
